module.exports = __webpack_public_path__ + "static/media/9.a46069f9.svg";